<template>
   <div class="form-group">
      <label
         for="ip_company"
         :class="['label-overlay', { active: !isNotEmpty(form.company) }]"
         @click="switchLabel($event)"
      >
         Company
      </label>
      <input
         id="ip_company"
         v-model.trim="form.company"
         type="text"
         class="form-control"
         name="company"
         :class="[
            { 'is-invalid': isValidCompany.isInvalid },
            { 'is-valid': isValidCompany.isValid },
         ]"
         @focus="switchLabel($event)"
         @blur="
            switchLabel($event);
            validateCompanyData();
            initiatedType();
         "
      />
      <div class="invalid-feedback">Where do you work, friend?</div>
      <div class="valid-feedback">You are in good company!</div>
   </div>
</template>

<script>
import person from '../../../util/userData.js';

export default {
   name: 'CompanyComponent',
   props: {
      value: {
         type: String,
         default: '',
      },
      options: {
         type: Object,
         default: null,
      },
   },
   data() {
      return {
         isValidCompany: {
            isValid: false,
            isInvalid: false,
         },
         form: {
            company: this.value,
         },
         ...(process.browser && { userProfileTracker: this.$tracker.userProfile }),
         person,
         ...(process.browser && { tracker: this.$tracker.tracker }),
      };
   },

   mounted() {
      if (this.person.profileData) {
         this.form.company = this.person.profileData.company || '';
      }
   },
   methods: {
      validateCompanyData() {
         this.isValidCompany.isValid = !this.isNotEmpty(this.form.company);
         this.isValidCompany.isInvalid =
            this.$parent.attemptSubmit && this.isNotEmpty(this.form.company);
      },
      reset() {
         this.isValidCompany.isInvalid = false;
         this.isValidCompany.isValid = false;
         this.form.company = '';
      },

      initiatedType() {
         if (this.form.company !== '') {
            this.userProfileTracker.information({ company: this.form.company });
         }

         if (
            typeof this.$parent.isFormInitiated === 'undefined' &&
            this.options &&
            this.options.mixpanelEve
         ) {
            this.$parent.isFormInitiated = true;
            this.tracker(this.options.mixpanelEve, {
               ...(this.options.name && { Name: this.options.name }),
               ...(this.options.type && { Type: this.options.type }),
               ...(this.options.product && { Product: this.options.product }),
               ...(this.options.framework && { Framework: this.options.framework }),
            });
         }
      },
   },
};
</script>

<style></style>
